import { ActionTypes } from '../constants/constants'
import AppDispatcher from '../dispatcher/appDispatcher'
import { BubbleNode } from '../types'
import Store from './store'

var _hoveredNode: BubbleNode
var _hoveredColor: string
class HoverStore extends Store {
  getHoveredNode() {
    return _hoveredNode
  }

  getHoveredColor() {
    return _hoveredColor
  }
}
var hoverStore = new HoverStore()

// @ts-ignore
hoverStore.dispatchToken = AppDispatcher.register(function (payload: any) {
  var action = payload.action

  switch (action.type) {
    case ActionTypes.SET_HOVERED_NODE: {
      if (action.node !== _hoveredNode) {
        _hoveredNode = action.node
        hoverStore.emitChange()
      }
      break
    }
    case ActionTypes.SET_HOVERED_COLOR: {
      if (action.color !== _hoveredColor) {
        _hoveredColor = action.color && !Number.isFinite(action.color) ? action.color : null
        hoverStore.emitChange()
      }
      break
    }
  }
})

export default hoverStore
